import { render, staticRenderFns } from "./churumbela.vue?vue&type=template&id=198aad04"
import script from "./churumbela.vue?vue&type=script&lang=js"
export * from "./churumbela.vue?vue&type=script&lang=js"
import style0 from "./churumbela.vue?vue&type=style&index=0&id=198aad04&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports